export const MIN_REVIEW_COUNT = 5;
